export enum ETipoDocumentoSUNAT {
  FACTURA = 'FACTURA',
  BOLETA = 'BOLETA',
  NOTA_VENTA = 'NOTA_VENTA',
  NOTA_CREDITO = 'NOTA_CREDITO',
  // NOTA_DEBITO = 'NOTA_DEBITO',
  // GUIA_REMISION = 'GUIA_REMISION',
  // RESUMEN_DIARIO = 'RESUMEN_DIARIO',
  // COMPROBANTE_RETENCION = 'COMPROBANTE_RETENCION',
  // COMPROBANTE_PERCEPCION = 'COMPROBANTE_PERCEPCION',
}
